<template>
  <div class="p-6">
    <!-- Header -->
    <div class="mb-6">
      <h2 class="text-2xl font-bold text-gray-800 mb-2">
        Nouvelle notification
      </h2>
      <p class="text-gray-600">
        Créez une nouvelle notification pour les utilisateurs
      </p>
    </div>

    <form @submit.prevent="handleSubmit" class="space-y-6">
      <!-- Basic Information -->
      <div class="bg-white rounded-xl p-6 border border-gray-200">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">
          Informations de base
        </h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <!-- Title -->
          <div class="md:col-span-2">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Titre <span class="text-red-500">*</span>
            </label>
            <input
              v-model="notification.title"
              type="text"
              required
              maxlength="100"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Titre de la notification"
            />
            <p class="text-xs text-gray-500 mt-1">
              {{ notification.title?.length || 0 }}/100 caractères
            </p>
          </div>

          <!-- Description -->
          <div class="md:col-span-2">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Description <span class="text-red-500">*</span>
            </label>
            <textarea
              v-model="notification.description"
              required
              maxlength="500"
              rows="4"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Description détaillée de la notification"
            ></textarea>
            <p class="text-xs text-gray-500 mt-1">
              {{ notification.description?.length || 0 }}/500 caractères
            </p>
          </div>
        </div>
      </div>

      <!-- Target Settings -->
      <div class="bg-white rounded-xl p-6 border border-gray-200">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">
          Paramètres de ciblage
        </h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <!-- Country Selection -->
          <!-- <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Pays <span class="text-red-500">*</span>
            </label>
            <select
              v-model="notification.country"
              required
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Sélectionner un pays</option>
              <option v-for="country in countries" :key="country.code" :value="country.code">
                {{ country.name }}
              </option>
            </select>
          </div> -->

          <!-- Target Type -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Cible <span class="text-red-500">*</span>
            </label>
            <select
              v-model="notification.target"
              required
              @change="onTargetChange"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Sélectionner une cible</option>
              <option value="all">Tout le monde</option>
              <option value="restaurant">Restaurants</option>
              <option value="user">Clients</option>
              <option value="rider">Livreurs</option>
              <!-- <option value="customersOfRank">
                Clients de rang spécifique
              </option> -->
            </select>
          </div>
          <div></div>

          <!-- Target Rank (if customersOfRank) -->
          <!-- <div v-if="notification.target === 'customersOfRank'">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Rang cible <span class="text-red-500">*</span>
            </label>
            <select
              v-model="notification.targetRank"
              required
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Sélectionner un rang</option>
              <option value="bronze">Bronze</option>
              <option value="silver">Argent</option>
              <option value="gold">Or</option>
              <option value="platinum">Platine</option>
              <option value="diamond">Diamant</option>
            </select>
          </div> -->

          <!-- Zone Selection -->
          <div v-if="false">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Zones (optionnel)
            </label>
            <div class="space-y-2">
              <div
                v-for="(zone, index) in notification.zone"
                :key="index"
                class="flex items-center space-x-2"
              >
                <input
                  v-model="notification.zone[index]"
                  type="text"
                  class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Ex: Abidjan, Cocody"
                />
                <button
                  type="button"
                  @click="removeZone(index)"
                  class="p-2 text-red-500 hover:bg-red-50 rounded-lg"
                >
                  <i class="pi pi-times"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addZone"
                class="w-full py-2 border border-dashed border-gray-300 rounded-lg text-gray-500 hover:border-gray-400 hover:text-gray-600"
              >
                <i class="pi pi-plus mr-2"></i>
                Ajouter une zone
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Media & Link Settings -->
      <div class="bg-white rounded-xl p-6 border border-gray-200" v-if="false">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">
          Média & Redirection
        </h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="md:col-span-2">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Image (optionnel)
            </label>
            <FileUploadWidget
              :maxFiles="1"
              :acceptedFiles="['image']"
              @saved="onImageUploaded"
              class="border rounded-xl p-4 bg-gray-50"
            />
          </div>

          <div class="md:col-span-2">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Lien de redirection (ex: /promo/123)
            </label>
            <input
              v-model="notification.link"
              type="text"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="URL ou chemin interne"
            />
          </div>
        </div>
      </div>

      <!-- Date Settings -->
      <div class="bg-white rounded-xl p-6 border border-gray-200" v-if="false">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">
          Date d'envoi
        </h3>

        <div class="space-y-4">
          <!-- Send Timing -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Quand envoyer ? <span class="text-red-500">*</span>
            </label>
            <div class="flex space-x-4">
              <label class="flex items-center">
                <input
                  v-model="sendTiming"
                  type="radio"
                  value="now"
                  class="mr-2"
                />
                <span class="text-sm">Tout de suite</span>
              </label>
              <label class="flex items-center">
                <input
                  v-model="sendTiming"
                  type="radio"
                  value="later"
                  class="mr-2"
                />
                <span class="text-sm">Plus tard</span>
              </label>
            </div>
          </div>

          <!-- Date/Time Picker (only when "Plus tard" is selected) -->
          <div v-if="sendTiming === 'later'">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Date et heure d'envoi <span class="text-red-500">*</span>
            </label>
            <input
              v-model="scheduledDateTime"
              type="datetime-local"
              :min="minDateTime"
              required
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
            <p class="text-xs text-gray-500 mt-1">
              La notification sera envoyée automatiquement à la date sélectionnée
            </p>
          </div>
        </div>
      </div>

      <!-- Preview -->
      <div class="bg-white rounded-xl p-6 border border-gray-200">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">Aperçu</h3>
        <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <div class="flex items-start space-x-3">
            <div
              class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0"
            >
              <i class="pi pi-bell text-white"></i>
            </div>
            <div class="flex-1">
              <h4 class="font-semibold text-gray-800">
                {{ notification.title || 'Titre de la notification' }}
              </h4>
              <p class="text-gray-600 text-sm mt-1">
                {{
                  notification.description || 'Description de la notification'
                }}
              </p>
              <div
                class="flex items-center space-x-4 mt-2 text-xs text-gray-500"
              >
                <span
                  ><i class="pi pi-globe mr-1"></i
                  >{{
                    getCountryName(notification.country) || 'Non spécifié'
                  }}</span
                >
                <span
                  ><i class="pi pi-users mr-1"></i
                  >{{ getTargetLabel(notification.target) }}</span
                >
                <span
                  ><i class="pi pi-flag mr-1"></i
                  >{{ getPriorityLabel(notification.priority) }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex justify-end space-x-3">
        <button
          type="button"
          @click="$emit('cancel')"
          class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
        >
          Annuler
        </button>
        <button
          type="submit"
          :disabled="isSubmitting || !isFormValid"
          class="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <i v-if="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
          Envoyer la notification
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { Countries } from '@/shared/utils/countries'
import FileUploadWidget from '@/presentation/components/input/FileUploadWidget.vue'

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(['submit', 'cancel'])

// Reactive data
const notification = ref({
  title: '',
  description: '',
  country: '',
  target: '',
  targetRank: '',
  zone: [],
  priority: 'normal',
  scheduleLater: false,
  scheduledDate: '',
  scheduledTime: '',
  image: '',
  link: '',
  ...props.initialData,
})

const isSubmitting = ref(false)

// Date/Time settings
const sendTiming = ref('now') // 'now' | 'later'
const scheduledDateTime = ref('')

// Minimum datetime is now
const minDateTime = computed(() => {
  const now = new Date()
  // Format: YYYY-MM-DDTHH:mm for datetime-local input
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  return `${year}-${month}-${day}T${hours}:${minutes}`
})

// Countries list
const countries = Object.values(Countries)

// Computed properties
const isFormValid = computed(() => {
  // Check if timing is selected
  const timingValid = sendTiming.value === 'now' || (sendTiming.value === 'later' && scheduledDateTime.value)

  return (
    notification.value.title?.trim() &&
    notification.value.description?.trim() &&
    notification.value.target &&
    timingValid
  )
})

// Methods
const onTargetChange = () => {
  if (notification.value.target !== 'customersOfRank') {
    notification.value.targetRank = ''
  }
}

const addZone = () => {
  notification.value.zone.push('')
}

const removeZone = index => {
  notification.value.zone.splice(index, 1)
}

const onImageUploaded = (data) => {
  if (data.files && data.files.length > 0) {
    notification.value.image = data.files[0].url
  } else {
    notification.value.image = ''
  }
}

const getCountryName = code => {
  const country = countries.find(c => c.code === code)
  return country?.name || code
}

const getTargetLabel = target => {
  const labels = {
    all: 'Tout le monde',
    restaurant: 'Restaurants',
    user: 'Clients',
    rider: 'Livreurs',
    customersOfRank: `Clients de rang: ${notification.value.targetRank || 'Non spécifié'}`,
  }
  return labels[target] || target
}

const getPriorityLabel = priority => {
  const labels = {
    low: 'Basse',
    normal: 'Normale',
    high: 'Haute',
    urgent: 'Urgente',
  }
  return labels[priority] || priority
}

const handleSubmit = async () => {
  if (!isFormValid.value) return

  isSubmitting.value = true

  try {
    // Prepare submission data
    const submissionData = {
      title: notification.value.title,
      description: notification.value.description,
      target: notification.value.target,
      targetRank: notification.value.targetRank,
      zone: notification.value.zone.filter(z => z.trim()),
      data: {
        image: notification.value.image,
        link: notification.value.link
      }
    }

    // Add scheduled datetime if "Plus tard" is selected
    if (sendTiming.value === 'later' && scheduledDateTime.value) {
      // Convert datetime-local (YYYY-MM-DDTHH:mm) to ISO format
      submissionData.scheduledDateTime = scheduledDateTime.value
    }

    emit('submit', submissionData)
  } catch (error) {
    console.error('Form submission error:', error)
  } finally {
    isSubmitting.value = false
  }
}

// Watch for initial data changes
watch(
  () => props.initialData,
  newData => {
    if (newData) {
      notification.value = {
        title: '',
        description: '',
        country: '',
        target: '',
        targetRank: '',
        zone: [],
        priority: 'normal',
        scheduleLater: false,
        scheduledDate: '',
        scheduledTime: '',
        ...newData,
      }
    }
  },
  { immediate: true },
)
</script>

<style scoped>
/* Custom animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bg-white {
  animation: slideIn 0.3s ease-out;
}

/* Custom focus styles */
input:focus,
textarea:focus,
select:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Radio button styles */
input[type='radio']:checked + span {
  color: #3b82f6;
  font-weight: 500;
}

/* Checkbox styles */
input[type='checkbox']:checked {
  background-color: #3b82f6;
  border-color: #3b82f6;
}
</style>
